"use client";

import { Autoplay, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import cn from "clsx";
import { useInView } from "react-intersection-observer";
import styles from "./CampusEmersion.module.scss";
import CampusEmersionCard from "@molecules/CampusEmersionCard/CampusEmersionCard";
import 'swiper/css/navigation';
import { useCallback, useRef } from "react";
export default function CampusEmersionCarousel({
  CampusData,
  isDesktop
}: {
  CampusData: any;
  isDesktop : boolean
}) {
  
  const sliderRef = useRef(null);

  const handlePrev = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.swiper.slidePrev();
  }, []);

  const handleNext = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.swiper.slideNext();
  }, []);

    return (
      <div className={cn(styles.root)}>
          <>
          <Swiper
            ref={sliderRef}
            modules={[Pagination, Autoplay]}
            spaceBetween={isDesktop ? 10 : 50}
            slidesPerView={isDesktop ? 4 : 1}
            autoplay={{
              delay: 6000,
            }}
            pagination={{ clickable: true }}
            className="Carousel__blueBullet Carousel__hAuto"
          >
            {CampusData?.ImageList?.map((imageData, i) => (
              <SwiperSlide key={i}>
                <CampusEmersionCard imageData={imageData} />
              </SwiperSlide>
            ))}
          </Swiper>
          <button className={cn(styles.swiperButtonPrev,"absolute")} onClick={handlePrev} > 
            <svg fill="#1b325d" width="50px" height="50px" viewBox="-128 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="M31.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L127.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L201.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34z"/></svg>
          </button>
          <button className={cn(styles.swiperButtonNext,"absolute -rotate-180")} onClick={handleNext}>
          <svg fill="#1b325d" width="50px" height="50px" viewBox="-128 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="M31.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L127.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L201.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34z"/></svg>
          </button>
          </>
      </div>
    );
}
